import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FlexGrid, CellRangeEventArgs, CellType, GridPanel } from '@grapecity/wijmo.grid';
import { Menu } from '@grapecity/wijmo.input';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { VMediumTypeComboBoxComponent } from '../../../commons/kymw02/combo-box/vmedium-type-combo-box/vmedium-type-combo-box.component';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { CoopCodeComboBoxComponent } from '../../../commons/kymw02/combo-box/coop-code-combo-box/coop-code-combo-box.component';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';

import { KYMW2500Model } from './kymw2500.model';
import { GetPageCopyModel } from './vo/get-page-copy.model';
import { OutputPagenationListModel } from './vo/output-pagenation-list.model';
import { PagenationRequestModel } from './vo/pagenation-request.model';
import { RegistPageCopyModel } from './vo/regist-page-copy.model';

import { DeletePageCopyLineService } from './api-services/delete-page-copy-line.service';
import { GetPageCopyService } from './api-services/get-page-copy.service';
import { GetPagenationDetailService } from './api-services/get-pagenation-detail.service';
import { OutputPagenationListService } from './api-services/output-pagenation-list.service';
import { RegistPageCopyService } from './api-services/regist-page-copy.service';

/**
 * ページネーション設定画面を管理するクラス
 *
 * @export KYMW2500Component
 * @class KYMW2500Component
 */
@Component({
  selector: 'app-kymw2500',
  templateUrl: 'kymw2500.component.html',
  styleUrls: ['kymw2500.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW2500Component extends PlessViewHelperSub implements OnInit {
  @ViewChild('dtg_PagenationList', { static: true }) dtg_PagenationList: FlexGrid;
  @ViewChild('dtg_PagenationDetail', { static: true }) dtg_PagenationDetail: FlexGrid;
  @ViewChild('cmb_MediumType', { static: true }) cmb_MediumType: VMediumTypeComboBoxComponent;
  @ViewChild('txt_OrderCodeFrom', { static: true }) txt_OrderCodeFrom: OrderCodeTextInputComponent;
  @ViewChild('txt_OrderCodeTo', { static: true }) txt_OrderCodeTo: OrderCodeTextInputComponent;
  @ViewChild('txt_OrderCode', { static: true }) txt_OrderCode: OrderCodeTextInputComponent;
  @ViewChild('cmb_CoopCode', { static: true }) cmb_CoopCode: CoopCodeComboBoxComponent;
  @ViewChild('lbl_DelivCatalogId', { static: true }) lbl_DelivCatalogId: ElementRef;
  @ViewChild('lbl_DelivCatalogIdFrom', { static: true }) lbl_DelivCatalogIdFrom: ElementRef;
  @ViewChild('lbl_DelivCatalogIdTo', { static: true }) lbl_DelivCatalogIdTo: ElementRef;
  @ViewChild('btn_Copy', { static: true }) btn_Copy: ElementRef;
  @ViewChild('btn_Output', { static: true }) btn_Output: ElementRef;
  @ViewChild('btn_Add', { static: true }) btn_Add: ElementRef;
  @ViewChild('btn_Edit', { static: true }) btn_Edit: ElementRef;
  @ViewChild('btn_Delete', { static: true }) btn_Delete: ElementRef;
  @ViewChild('btn_Unset', { static: true }) btn_Unset: ElementRef;
  @ViewChild('btn_Initialize', { static: true }) btn_Initialize: ElementRef;
  @ViewChild('btn_AddPage', { static: true }) btn_AddPage: ElementRef;
  @ViewChild('btn_DeletePage', { static: true }) btn_DeletePage: ElementRef;
  @ViewChild('btn_Set', { static: true }) btn_Set: ElementRef;

  // ウィンドウを閉じる際の処理
  public closeFunction: Function = null;
  /**
   * ページネーション詳細にて取り扱う生協の数
   */
  private readonly COOP_NUM: number = Number(9);

  /**
   * 生協コードのリスト
   * （[いばらき、とちぎ、ぐんま、ちば、さいたま、とうきょう、ながの、にいがた、クルコ] の順）
   */
  private readonly COOP_CODE: Array<string> = [this.kymw00Model.COOP_CODE_IB, this.kymw00Model.COOP_CODE_TO, this.kymw00Model.COOP_CODE_GU, this.kymw00Model.COOP_CODE_TI, this.kymw00Model.COOP_CODE_SA, this.kymw00Model.COOP_CODE_TK, this.kymw00Model.COOP_CODE_NA, this.kymw00Model.COOP_CODE_NI, this.kymw00Model.COOP_CODE_KU];

  private readonly PAGENATION_DETAIL_COLUMNS: Array<string> = [
    'KihanPage',
    'IbarakiPage',
    'TochigiPage',
    'GunnmaPage',
    'ChibaPage',
    'SaitamaPage',
    'TokyoPage',
    'NaganoPage',
    'NiigataPage',
    'KurucoPage'
  ];

  /**
   * ページネーションリクエストVO
   */
  private pagenationRequestVO: PagenationRequestModel = null;

  /**
   * ページネーション詳細設定VO
   */
  private registPageCopyVO: RegistPageCopyModel = null;

  /**
   * Manageオブジェクト
   */
  public kymw2500Model: KYMW2500Model = new KYMW2500Model();

  /**
   * データグリッド「ページネーション詳細」で選択した列のインデックス値
   */
  private pagenationDetailClickColumnIndex = Number(-1);

  /**
   * データグリッド「ページネーション詳細」で選択した行のインデックス値
   */
  private pagenationDetailClickRowIndex = Number(-1);

  /**
   * 設定処理でデータグリッド「ページネーション詳細」からサーバに送信する列のインデックス名リスト
   * （[いばらき、とちぎ、ぐんま、ちば、さいたま、とうきょう、ながの、にいがた、クルコ] の順）
   */
  private pagenationDetailRequestColumns: Array<any> = new Array<any>(this.COOP_NUM);

  // ページネーション詳細編集不可フラグ
  public readonlyPagenationDetail = Boolean(true);
  // グリッドヘッダーテキスト(基版)
  public headerKihanPage = String('基版');
  // セル編集可能フラグ
  public cellEditFlag = Boolean(false);
  // グリッドリフレッシュフラグ
  public gridRefreshFlag = Boolean(true);
  // コンテキストメニュー
  private contextMenu: Menu;


  /**
   *Creates an instance of KYMW2500Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {ElementRef} elementRef
   * @param {DeletePageCopyLineService} deletePageCopyLineService
   * @param {GetPageCopyService} getPageCopyService
   * @param {GetPagenationDetailService} getPagenationDetailService
   * @param {OutputPagenationListService} outputPagenationListService
   * @param {RegistPageCopyService} registPageCopyService
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @memberof KYMW2500Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private deletePageCopyLineService: DeletePageCopyLineService,
    private getPageCopyService: GetPageCopyService,
    private getPagenationDetailService: GetPagenationDetailService,
    private outputPagenationListService: OutputPagenationListService,
    private registPageCopyService: RegistPageCopyService,
    public fileDownloadConfirmService: FileDownloadConfirmService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW2500Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW2500';
    this.kymw2500Model.kymw2500Component = this;

    // コンテキストメニューの設定(ポイントリスト)
    this.setContextMenu();

    // ページネーション選択エリアのボタンを非活性化
    setTimeout(() => {
      this.plessEnabledSetting();
    });

    // グリッド初期処理
    this.gridInit();
  }
  public plessEnabledSetting() {
    // ページネーション選択エリアのボタンを非活性化
    this.disablePagenationListButton();
    // ページネーション詳細エリアを非活性化
    this.disablePagenationDetail();
  }

  private setContextMenu(): void {
    this.contextMenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: '出力', cmd: 'output' },
        ],
        command: this.getFormatMenuCommand(),
        // イベント設定
        itemClicked: (s, e) => {
          switch (this.contextMenu.selectedValue) {
            case 'output':
              this.eventOutput_CLICKHandler();
              break;
          }
        }
      }
    );

    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_PagenationList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextMenu !== undefined) {
        // コンテキストメニューの活性非活性制御
        this.contextMenu.itemsSource.forEach(item => {
          let enableFlag = Boolean(false);
          if (this.dtg_PagenationList.selection.row >= 0) {
            enableFlag = true;
          }
          item.enabled = this.setContextMenuEnabled(item, enableFlag);
        });
        this.contextMenu.show(e);
      }
    });

    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextMenu.itemsSource[0], 'none');
  }

  private getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return (!param.enabled) ? false : true;
      }
    };
  }

  /**
   * グリッド初期処理
   *
   * @private
   * @memberof KYMW2500Component
   */
  private gridInit() {
    // ページネーションリストデータ変更時
    this.dtg_PagenationList.itemsSourceChanged.addHandler((s: FlexGrid, e: CellRangeEventArgs) => {
      this.dtg_PagenationList.select(-1, -1);
    });

    // ページネーション詳細データ変更時
    this.dtg_PagenationDetail.itemsSourceChanged.addHandler((s: FlexGrid, e: CellRangeEventArgs) => {
      if (this.gridRefreshFlag) {
        this.dtg_PagenationDetail.select(-1, -1);
      } else {
        this.dtg_PagenationDetail.select(this.pagenationDetailClickRowIndex, -1);
      }
      this.gridRefreshFlag = true;
    });

    // マウスによるセル選択時のみセルを編集モードにする
    this.dtg_PagenationDetail.hostElement.addEventListener('mousedown', (e: MouseEvent) => {
      this.cellEditFlag = true;
    });

    // 選択行変更時処理
    this.dtg_PagenationDetail.selectionChanged.addHandler((s: FlexGrid, e: CellRangeEventArgs) => {
      if (this.cellEditFlag) {
        setTimeout(function () {
          s.startEditing(false);
        });
        this.cellEditFlag = false;
      }
      // 列のインデックス値を退避
      this.pagenationDetailClickColumnIndex = e.col;
      // 行のインデックス値を退避
      this.pagenationDetailClickRowIndex = e.row;
      // 削除ボタンの活性・非活性判定
      if (!this.readonlyPagenationDetail) {
        this.setBtnPageDeleteEnabled();
      }
    });

    this.dtg_PagenationDetail.itemFormatter = (panel: GridPanel, r: number, c: number, cell: HTMLElement) => {
      // セルチェック
      if (panel.cellType === CellType.Cell) {
        // 背景色設定
        if (this.dtg_PagenationDetail.columns[c].binding === 'KihanPage') {
          cell.classList.add('kihan-color');
        }
      }
    };
  }

  /**
   * コンボボックス「媒体」チェンジイベントリスナ
   *
   * @memberof KYMW2500Component
   */
  public eventMediumType_CHANGEHandler(): void {
    // ページネーション詳細エリアを非活性化
    this.disablePagenationDetail();

    // ページネーション選択エリアのボタンの非活性化
    this.disablePagenationListButton();

    // 表示データをクリア

    // ページネーション詳細エリア
    this.clearPagenationDetail();

    // ページネーション選択エリア
    this.clearPagenationList();
  }

  /**
   * ボタン「表示」クリックイベントリスナ
   *
   * @returns {void}
   * @memberof KYMW2500Component
   */
  public eventDisplay_CLICKHandler(): void {
    // VO設定
    const vo: GetPageCopyModel = new GetPageCopyModel();

    // 媒体区分
    vo.MediumType = this.cmb_MediumType.selectedMediumType;
    // 適用開始 受注コード From
    vo.OrderCodeFrom = this.txt_OrderCodeFrom.text;
    // 適用開始 受注コード To
    vo.OrderCodeTo = this.txt_OrderCodeTo.text;

    // 入力チェック
    if (!this.inputCheckGetPageCopy(vo)) {
      return;
    }

    // ページネーション詳細一覧をクリアさせる
    this.kymw2500Model.clearPageNationDetailFlg = true;

    // ページネーション設定一覧取得
    this.getPageCopyService.execute(this.kymw2500Model, vo);
  }

  /**
   * データグリッド「ページネーション設定一覧」チェンジイベントリスナ
   *
   * @memberof KYMW2500Component
   */
  public eventPagenationList_CHANGEHandler(): void {

    // ページネーション詳細エリアを非活性化
    this.disablePagenationDetail();

    // ページネーション詳細一覧をクリア状態にする場合はフラグを初期化して後続処理を行わない
    if (this.kymw2500Model.clearPageNationDetailFlg) {
      this.kymw2500Model.clearPageNationDetailFlg = false;
      return;
    }

    if (this.dtg_PagenationList.selection.row < 0) {
      // 行選択なし：ページネーション選択エリアのボタンを非活性化
      this.disablePagenationListButton();
    } else {
      // 行選択あり：ページネーション選択エリアのボタンを活性化
      this.enablePagenationListButton();

      // VO設定
      const vo: PagenationRequestModel = new PagenationRequestModel();
      // 媒体区分
      vo.MediumType = this.kymw2500Model.getGetPageCopyVO().MediumType;
      // 適用開始 受注コード
      vo.OrderCode = this.dtg_PagenationList.selectedItems[0].OrderCode;
      // 基版ページ作成生協コード
      vo.CoopCode = this.dtg_PagenationList.selectedItems[0].CoopCode;
      // 選択行のインデックス値
      vo.SelectedIndex = this.dtg_PagenationList.selection.row;

      // グループを保持
      this.kymw2500Model.setGroup(this.dtg_PagenationList.selectedItems[0].Group);

      // ページネーション詳細取得
      this.getPagenationDetailService.execute(this.kymw2500Model, vo);
    }
    // }
  }

  /**
   * ボタン「コピー」クリックイベントリスナ
   *
   * @memberof KYMW2500Component
   */
  public eventCopy_CLICKHandler(): void {
    // ページネーション選択エリアのボタンを非活性化
    this.disablePagenationListButton();
    // ページネーション設定一覧を未選択にする
    this.dtg_PagenationList.select(-1, -1);
    // 適用開始受注コードをクリア
    this.kymw2500Model.orderCode = '';
    this.txt_OrderCode.setOrderCode('');
    // グループをクリア
    this.kymw2500Model.setGroup('');
    // ページネーション詳細エリアを活性化
    this.enablePagenationDetail('a');
  }

  /**
   * ボタン「追加」クリックイベントリスナ
   *
   * @memberof KYMW2500Component
   */
  public eventAdd_CLICKHandler(): void {
    // ページネーション選択エリアのボタンを非活性化
    this.disablePagenationListButton();
    // ページネーション設定一覧を未選択にする
    this.dtg_PagenationList.select(-1, -1);
    // ページネーション詳細エリアを初期化
    this.clearPagenationDetail();
    this.kymw2500Model.addPagenationDetailLine();
    // ページネーション詳細エリアを活性化
    this.enablePagenationDetail('a');
  }

  /**
   * ボタン「編集」クリックイベントリスナ
   *
   * @memberof KYMW2500Component
   */
  public eventEdit_CLICKHandler(): void {
    // ページネーション詳細エリアを活性化
    this.enablePagenationDetail('e');
  }

  /**
   * ボタン「削除」クリックイベントリスナ
   *
   * @memberof KYMW2500Component
   */
  public eventDelete_CLICKHandler(): void {
    if (this.dtg_PagenationList.selection.row < 0) {
      // 行選択なし：ページネーション選択エリアのボタンを非活性化
      this.disablePagenationListButton();
    } else {
      // 行選択あり
      // VO設定
      const vo: PagenationRequestModel = new PagenationRequestModel();

      // 媒体区分
      vo.MediumType = this.kymw2500Model.getGetPageCopyVO().MediumType;
      // 適用開始 受注コード
      vo.OrderCode = this.dtg_PagenationList.selectedItems[0].OrderCode;
      // 基版ページ作成生協コード
      vo.CoopCode = this.dtg_PagenationList.selectedItems[0].CoopCode;
      // 選択行のインデックス値
      vo.SelectedIndex = this.dtg_PagenationList.selection.row;

      // 確認メッセージのイベントリスナメソッドにVOを渡す為に、インスタンス変数にセットする
      this.pagenationRequestVO = vo;

      // 確認メッセージを表示
      this.dialogService.openAlertGetMessage(
        'Q0106',
        [this.dtg_PagenationList.selectedItems[0].OrderCode],
        (closeDetail) => {
          this.eventAlert1_CLICKHandler(closeDetail);
        }
      );
    }
  }

  /**
   * 削除処理確認メッセージイベントリスナ
   *
   * @memberof KYMW2500Component
   */
  public eventAlert1_CLICKHandler(closeDetail: number): void {
    if (closeDetail === PlessAlert.Yes) {
      // ページネーション詳細一覧をクリアさせる
      this.kymw2500Model.clearPageNationDetailFlg = true;
      // ページネーション設定削除
      this.deletePageCopyLineService.execute(this.kymw2500Model, this.pagenationRequestVO);
    }
  }

  /**
   * コンボボックス「適用開始受注コード」チェンジイベントリスナ
   *
   * @memberof KYMW2500Component
   */
  public eventOrderCode_CHANGEHandler(): void {
    // 入力した適用受注コードがマスタに存在する場合のみボタンを活性にする
    this.enablePagenationDetailButton();
  }

  /**
   * コンボボックス「基版ページ作成生協」チェンジイベントリスナ
   *
   * @memberof KYMW2500Component
   */
  public eventCoopCode_CHANGEHandler(): void {
    // 重複チェック
    if (this.kymw2500Model.getCoopCodeIndex() > 0) {
      // コンボボックス「基版ページ作成生協」で生協が選択されている場合：確認メッセージあり
      this.dialogService.openAlertGetMessage(
        'Q0118',
        null,
        (closeDetail) => {
          this.eventAlert2_CLICKHandler(closeDetail);
        }
      );
    } else {
      // コンボボックス「基版ページ作成生協」で生協が選択されている場合：確認メッセージなし
      // コンボボックス「基版ページ作成生協」の選択内容を確定する
      this.kymw2500Model.setCoopCodeIndex(this.cmb_CoopCode.selectedIndex);
      // データグリッド「ページネーション詳細」の列を設定
      this.setPagenationDetaiColumns();
    }
  }

  /**
   * 基版ページ作成生協変更確認メッセージイベントリスナ
   *
   * @memberof KYMW2500Component
   */
  public eventAlert2_CLICKHandler(closeDetail: number): void {
    if (closeDetail === PlessAlert.Yes) {
      // コンボボックス「基版ページ作成生協」の選択内容を確定する
      this.kymw2500Model.setCoopCodeIndex(this.cmb_CoopCode.selectedIndex);
      // データグリッド「ページネーション詳細」の列を設定
      this.setPagenationDetaiColumns();
    } else {
      // コンボボックス「基版ページ作成生協」の選択内容を元に戻す
      const coopCode: string = this.kymw2500Model.coopCode;
      this.cmb_CoopCode.setCoopCode(coopCode);
    }
    this.kymw2500Model.coopCode = this.cmb_CoopCode.selectedCoopCode;
  }

  /**
   * ボタン「未設定」クリックイベントリスナ
   *
   * @memberof KYMW2500Component
   */
  public eventUnset_CLICKHandler(): void {
    if (this.dtg_PagenationDetail.selection.row >= 0) {
      // セルの位置
      const row: number = this.dtg_PagenationDetail.selection.row;
      const columnName: string = this.PAGENATION_DETAIL_COLUMNS[this.pagenationDetailClickColumnIndex];
      // 設定する値
      const value = String('未設定');

      // セルの値を変更
      this.kymw2500Model.setPagenationDetailCell(row, columnName, value);
      this.kymw2500Model.refreshPagenationDetail();
    }
  }

  /**
   * ボタン「初期化」クリックイベントリスナ
   *
   * @memberof KYMW2500Component
   */
  public eventInitialize_CLICKHandler(): void {
    if (this.dtg_PagenationDetail.selection.row >= 0) {
      // セルの位置
      const row: number = this.dtg_PagenationDetail.selection.row;
      const columnName: string = this.PAGENATION_DETAIL_COLUMNS[this.pagenationDetailClickColumnIndex];
      // 設定する値
      const value: string = this.dtg_PagenationDetail.selectedItems[0].KihanPage;

      // セルの値を変更
      this.kymw2500Model.setPagenationDetailCell(row, columnName, value);
      this.kymw2500Model.refreshPagenationDetail();
    }
  }

  /**
   * データグリッド「ページネーション詳細」アイテムフォーカスインイベントリスナ
   *
   * @memberof KYMW2500Component
   */
  public eventPagenationDetail_ITEM_FOCUS_INHandler(): void {
    // 削除ボタンの活性・非活性判定
    this.setBtnPageDeleteEnabled();
  }

  /**
   * ボタン「ページ追加」クリックイベントリスナ
   *
   * @memberof KYMW2500Component
   */
  public eventAddPage_CLICKHandler(): void {
    this.gridRefreshFlag = false;

    this.kymw2500Model.addPagenationDetailLine();

    // ボタン「ページ削除」の活性状態を設定
    this.setBtnPageDeleteEnabled();
  }

  /**
   * ボタン「ページ削除」クリックイベントリスナ
   *
   * @memberof KYMW2500Component
   */
  public eventDeletePage_CLICKHandler(): void {
    // データグリッド「ページネーション詳細」が 2 ページ分以上入力されている場合のみ削除可能
    if (this.kymw2500Model.getPagenationDetailLength() > 1) {
      // 選択行を削除
      this.kymw2500Model.deletePagenationDetailLine(this.pagenationDetailClickRowIndex);

      // データグリッド「ページネーション詳細」の選択状態を解除
      this.dtg_PagenationDetail.select(-1, -1);
      this.pagenationDetailClickColumnIndex = -1;
      this.pagenationDetailClickRowIndex = -1;
    }

    // ボタン「ページ削除」の活性状態を設定
    this.setBtnPageDeleteEnabled();
  }

  /**
   * ボタン「設定」クリックイベントリスナ
   *
   * @memberof KYMW2500Component
   */
  public eventSet_CLICKHandler(): void {
    // VO設定
    const vo: RegistPageCopyModel = new RegistPageCopyModel();

    // 媒体区分
    vo.MediumType = this.cmb_MediumType.selectedMediumType;
    if (this.kymw2500Model.getMode() === 'e') {
      // 変更前使用開始受注コード
      vo.BeforeOrderCode = this.kymw2500Model.getGetPagenationDetailVO().OrderCode;
      // 変更前基版ページ作成生協コード
      vo.BeforeCoopCode = this.kymw2500Model.getGetPagenationDetailVO().CoopCode;
    }
    // 適用開始 受注コード
    vo.OrderCode = this.kymw2500Model.orderCode;
    // 基版ページ生成生協
    vo.CoopCode = this.cmb_CoopCode.selectedCoopCode;
    // ページネーション詳細
    // いばらき
    vo.IbarakiPageList = this.kymw2500Model.getCoopPagenationDetailList(this.pagenationDetailRequestColumns[0]);
    // とちぎ
    vo.TochigiPageList = this.kymw2500Model.getCoopPagenationDetailList(this.pagenationDetailRequestColumns[1]);
    // ぐんま
    vo.GunnmaPageList = this.kymw2500Model.getCoopPagenationDetailList(this.pagenationDetailRequestColumns[2]);
    // ちば
    vo.ChibaPageList = this.kymw2500Model.getCoopPagenationDetailList(this.pagenationDetailRequestColumns[3]);
    // さいたま
    vo.SaitamaPageList = this.kymw2500Model.getCoopPagenationDetailList(this.pagenationDetailRequestColumns[4]);
    // とうきょう
    vo.TokyoPageList = this.kymw2500Model.getCoopPagenationDetailList(this.pagenationDetailRequestColumns[5]);
    // ながの
    vo.NaganoPageList = this.kymw2500Model.getCoopPagenationDetailList(this.pagenationDetailRequestColumns[6]);
    // にいがた
    vo.NiigataPageList = this.kymw2500Model.getCoopPagenationDetailList(this.pagenationDetailRequestColumns[7]);
    // クルコ
    vo.KurucoPageList = this.kymw2500Model.getCoopPagenationDetailList(this.pagenationDetailRequestColumns[8]);

    // 入力チェック
    if (!this.inputCheckRegistPageCopy(vo)) {
      return;
    }

    // 確認メッセージのイベントリスナメソッドにVOを渡す為に、インスタンス変数にセットする
    this.registPageCopyVO = vo;

    // 確認メッセージを表示
    let messageCode: string = null;
    if (this.kymw2500Model.getMode() === 'a') {
      messageCode = 'Q0104';
    } else {
      messageCode = 'Q0105';
    }

    this.dialogService.openAlertGetMessage(
      messageCode,
      ['ページネーション'],
      (closeDetail) => {
        this.eventAlert3_CLICKHandler(closeDetail);
      }
    );
  }

  /**
   * 設定処理確認メッセージイベントリスナ
   *
   * @private
   * @param {number} closeDetail メッセージ回答
   * @memberof KYMW2500Component
   */
  public eventAlert3_CLICKHandler(closeDetail: number): void {
    if (closeDetail === PlessAlert.Yes) {
      // ページネーション詳細一覧をクリアさせる
      this.kymw2500Model.clearPageNationDetailFlg = true;

      // ページネーション設定一覧取得
      this.registPageCopyService.execute(this.kymw2500Model, this.registPageCopyVO);
    }
  }

  /*--------------------------------------------------------------------------------------------------
    「出力」イベント(ボタン、コンテキストメニュー選択)
  ---------------------------------------------------------------------------------------------------*/
  /**
   * コンテキスト「出力」メニュー選択イベント
   *
   * @memberof KYMW2500Component
   */
  public eventOutput_CLICKHandler(): void {
    // VO設定
    const vo: OutputPagenationListModel = new OutputPagenationListModel();
    // 出力区分（1:ページネーション設定画面、 2:基版コピー・フェーズ管理画面）
    vo.OutputDiv = '1';
    // 適用開始 受注コード
    vo.OrderCode = this.dtg_PagenationList.selectedItems[0].OrderCode;
    // 媒体区分
    vo.MediumType = this.kymw2500Model.getGetPageCopyVO().MediumType;

    // ページネーション情報出力
    this.outputPagenationListService.execute(this.kymw2500Model, vo,
      (data: any) => {
        // ファイル名の設定
        const fileName = 'ページネーション情報.xls';

        // ファイルダウンロード
        this.fileDownloadConfirmService.show(data.FileName, fileName);
      });
  }

  /**
   * ページネーション選択エリアをクリアする
   *
   * @memberof KYMW2500Component
   */
  public clearPagenationList(): void {
    // 適用開始受注コード From
    this.txt_OrderCodeFrom.setOrderCode('');
    // 適用開始受注コード From
    this.txt_OrderCodeTo.setOrderCode('');

    // データグリッド
    this.kymw2500Model.updatePagenationList(null, null);
  }

  /**
   * ページネーション選択エリアのボタンを活性にする
   *
   * @memberof KYMW2500Component
   */
  public enablePagenationListButton(): void {
    // ボタン「コピー」
    this.plessEnabled(this.btn_Copy, true);
    // ボタン「出力」
    this.plessEnabled(this.btn_Output, true);
    // ボタン「編集」
    this.plessEnabled(this.btn_Edit, true);
    // ボタン「削除」
    this.plessEnabled(this.btn_Delete, true);
  }

  /**
   * ページネーション選択エリアのリスト、ボタンを非活性にする
   *
   * @memberof KYMW2500Component
   */
  public disablePagenationListButton(): void {
    // ボタン「コピー」
    this.plessEnabled(this.btn_Copy, false);
    // ボタン「追加」（「媒体」が選択されていれば、非活性にしない）
    if (PlessViewUtilsSub.trim(this.cmb_MediumType.selectedMediumType) === '') {
      this.plessEnabled(this.btn_Add, false);
    } else {
      this.plessEnabled(this.btn_Add, true);
    }
    // ボタン「出力」
    this.plessEnabled(this.btn_Output, false);
    // ボタン「編集」
    this.plessEnabled(this.btn_Edit, false);
    // ボタン「削除」
    this.plessEnabled(this.btn_Delete, false);
  }

  /**
   * データグリッド「ページネーション設定一覧」を最新の情報に更新する
   *
   * @returns {void}
   * @memberof KYMW2500Component
   */
  public reloadPagenationList(): void {
    // VO設定
    const vo: GetPageCopyModel = this.kymw2500Model.getGetPageCopyVO();

    // 取得条件チェック
    if (PlessViewUtilsSub.isEmpty(vo.MediumType)) {
      // ページネーション設定一覧の取得処理が1度も行われていない場合は、取得処理を行わない
      return;
    }

    // ページネーション設定一覧取得
    this.getPageCopyService.execute(this.kymw2500Model, vo);
  }

  /**
   * ページネーション詳細エリアをクリアする
   *
   * @memberof KYMW2500Component
   */
  public clearPagenationDetail(): void {
    // ヘッダ情報
    // グループをクリア
    this.kymw2500Model.setGroup('');
    this.setPagenationDetaiHeader('', '');

    // データグリッド
    this.kymw2500Model.updatePagenationDetail(null, null);
    this.pagenationDetailClickColumnIndex = -1;
  }

  /**
   * ページネーション詳細エリアのリスト、ボタンを活性にする
   * （設定モードに「編集」を指定した場合は受注コードのみ編集不可とする）
   *
   * @param {string} mode 設定モード　'a':追加  'e':編集
   * @memberof KYMW2500Component
   */
  public enablePagenationDetail(mode: string): void {
    // テキスト「受注コード」
    if (mode === 'a') {
      this.plessEnabled(this.txt_OrderCode, true);
    } else if (mode === 'e') {
      this.plessEnabled(this.txt_OrderCode, false);
    }
    // コンボボックス「基版ページ作成生協」
    this.plessEnabled(this.cmb_CoopCode, true);
    // データグリッド「ページネーション詳細」
    this.readonlyPagenationDetail = false;
    // ボタン
    this.enablePagenationDetailButton();

    // 設定モードを退避
    this.kymw2500Model.setMode(mode);
  }

  /**
   * ページネーション詳細エリアのボタンを活性にする
   *
   * @memberof KYMW2500Component
   */
  public enablePagenationDetailButton(): void {
    // 入力した適用受注コードがマスタに存在する場合のみボタンを活性にする
    if (PlessViewUtilsSub.isEmpty(this.lbl_DelivCatalogId.nativeElement.value)) {
      this.disablePagenationDetailButton();
    } else {
      // ページネーション詳細の行を設定
      this.pagenationDetailClickRowIndex = this.dtg_PagenationDetail.selection.row;

      // ボタン「未設定」
      this.plessEnabled(this.btn_Unset, true);
      // ボタン「初期化」
      this.plessEnabled(this.btn_Initialize, true);
      // ボタン「ページ追加」
      this.plessEnabled(this.btn_AddPage, true);
      // ボタン「ページ削除」
      this.setBtnPageDeleteEnabled();
      // ボタン「設定」
      this.plessEnabled(this.btn_Set, true);
    }
  }

  /**
   * ボタン「ページ削除」を活性にする。
   * データグリッド「ページネーション詳細」が 2 行以上：活性
   * データグリッド「ページネーション詳細」が 1 行以下：非活性
   *
   * @memberof KYMW2500Component
   */
  public setBtnPageDeleteEnabled(): void {
    if (this.kymw2500Model.getPagenationDetailLength() > 1 && this.pagenationDetailClickRowIndex > -1) {
      this.plessEnabled(this.btn_DeletePage, true);
    } else {
      this.plessEnabled(this.btn_DeletePage, false);
    }
  }

  /**
   * ページネーション詳細エリアのリスト、ボタンを非活性にする
   *
   * @memberof KYMW2500Component
   */
  public disablePagenationDetail(): void {
    // テキスト「受注コード」
    this.plessEnabled(this.txt_OrderCode, false);
    // コンボボックス「基版ページ作成生協」
    this.plessEnabled(this.cmb_CoopCode, false);
    // データグリッド「ページネーション詳細」
    this.readonlyPagenationDetail = true;
    // ボタン
    this.disablePagenationDetailButton();

    // 設定モードをクリア
    this.kymw2500Model.setMode('');
  }

  /**
   * ページネーション詳細エリアのボタンを非活性にする
   *
   * @memberof KYMW2500Component
   */
  public disablePagenationDetailButton(): void {
    // ボタン「未設定」
    this.plessEnabled(this.btn_Unset, false);
    // ボタン「初期化」
    this.plessEnabled(this.btn_Initialize, false);
    // ボタン「ページ追加」
    this.plessEnabled(this.btn_AddPage, false);
    // ボタン「ページ削除」
    this.plessEnabled(this.btn_DeletePage, false);
    // ボタン「設定」
    this.plessEnabled(this.btn_Set, false);
  }

  /**
   * ページネーション詳細エリアのヘッダ情報を設定する
   *
   * @param {string} orderCode 適用開始 受信コード
   * @param {string} coopCode 基版ページ作成生協
   * @memberof KYMW2500Component
   */
  public setPagenationDetaiHeader(orderCode: string, coopCode: string): void {
    // テキスト入力「適用開始 受注コード」
    this.kymw2500Model.orderCode = orderCode;
    this.txt_OrderCode.setOrderCode(orderCode);
    this.cmb_CoopCode.setCoopCode(coopCode);
    this.kymw2500Model.coopCode = coopCode;

    // コンボボックス「基版ページ作成生協」の選択内容を確定する
    this.kymw2500Model.setCoopCodeIndex(this.cmb_CoopCode.selectedIndex);

    // データグリッドの列を設定
    this.setPagenationDetaiColumns();
  }

  /**
   * コンボボックス「基版ページ作成生協」をもとに、データグリッド「ページネーション詳細」の列を設定する
   *
   * @private
   * @memberof KYMW2500Component
   */
  private setPagenationDetaiColumns(): void {
    // 設定処理時にサーバへ送信する列のリストを初期化
    for (let i = Number(0); i < this.COOP_NUM; i++) {
      this.pagenationDetailRequestColumns[i] = this.PAGENATION_DETAIL_COLUMNS[i + 1];
    }

    // 基版ページ作成生協の列を表示する
    this.headerKihanPage = this.cmb_CoopCode.model.coopList[this.kymw2500Model.getCoopCodeIndex()].PlanCoopName;

    // 各生協の列を表示する
    this.kymw2500Model.visibleKihanPage = true;
    this.kymw2500Model.visibleIbarakiPage = true;
    this.kymw2500Model.visibleTochigiPage = true;
    this.kymw2500Model.visibleGunnmaPage = true;
    this.kymw2500Model.visibleChibaPage = true;
    this.kymw2500Model.visibleSaitamaPage = true;
    this.kymw2500Model.visibleTokyoPage = true;
    this.kymw2500Model.visibleNaganoPage = true;
    this.kymw2500Model.visibleNiigataPage = true;
    this.kymw2500Model.visibleKurucoPage = true;

    // 基版ページに選択された生協の列を非表示にし、サーバへ送信する列として基版ページを設定する
    const coopCode: string = this.cmb_CoopCode.selectedCoopCode;
    switch (coopCode) {
      case this.COOP_CODE[0]:                                                   // いばらき
        this.kymw2500Model.visibleIbarakiPage = false;
        this.pagenationDetailRequestColumns[0] = this.PAGENATION_DETAIL_COLUMNS[0];
        break;

      case this.COOP_CODE[1]:                                                   // とちぎ
        this.kymw2500Model.visibleTochigiPage = false;
        this.pagenationDetailRequestColumns[1] = this.PAGENATION_DETAIL_COLUMNS[0];
        break;

      case this.COOP_CODE[2]:                                                   // ぐんま
        this.kymw2500Model.visibleGunnmaPage = false;
        this.pagenationDetailRequestColumns[2] = this.PAGENATION_DETAIL_COLUMNS[0];
        break;

      case this.COOP_CODE[3]:                                                   // ちば
        this.kymw2500Model.visibleChibaPage = false;
        this.pagenationDetailRequestColumns[3] = this.PAGENATION_DETAIL_COLUMNS[0];
        break;

      case this.COOP_CODE[4]:                                                   // さいたま
        this.kymw2500Model.visibleSaitamaPage = false;
        this.pagenationDetailRequestColumns[4] = this.PAGENATION_DETAIL_COLUMNS[0];
        break;

      case this.COOP_CODE[5]:                                                   // とうきょう
        this.kymw2500Model.visibleTokyoPage = false;
        this.pagenationDetailRequestColumns[5] = this.PAGENATION_DETAIL_COLUMNS[0];
        break;

      case this.COOP_CODE[6]:                                                   // ながの
        this.kymw2500Model.visibleNaganoPage = false;
        this.pagenationDetailRequestColumns[6] = this.PAGENATION_DETAIL_COLUMNS[0];
        break;

      case this.COOP_CODE[7]:                                                   // にいがた
        this.kymw2500Model.visibleNiigataPage = false;
        this.pagenationDetailRequestColumns[7] = this.PAGENATION_DETAIL_COLUMNS[0];
        break;

      case this.COOP_CODE[8]:                                                   // クルコ
        this.kymw2500Model.visibleKurucoPage = false;
        this.pagenationDetailRequestColumns[8] = this.PAGENATION_DETAIL_COLUMNS[0];
        break;

      default:
        // 選択されていない場合は、基版ページ作成生協の列を非表示にする
        this.kymw2500Model.visibleKihanPage = false;
        break;
    }
  }

  /**
   * ページネーション設定一覧取得の入力チェック
   *
   * @param vo    サーバへのリクエストデータ
   * @return true:OK false:NG
   */
  private inputCheckGetPageCopy(vo: GetPageCopyModel): boolean {
    // 「媒体」
    if (PlessViewUtilsSub.trim(vo.MediumType) === '') {
      this.dialogService.openAlertGetMessage('E0110', ['媒体']);
      return false;
    }

    // 「適用開始受注コード(From)」
    // 必須チェック
    if (PlessViewUtilsSub.isEmpty(vo.OrderCodeFrom)) {
      this.dialogService.openAlertGetMessage('E0110', ['適用開始受注コード(From)']);
      return false;
    }
    // 存在チェック
    if (PlessViewUtilsSub.isEmpty(this.lbl_DelivCatalogIdFrom.nativeElement.value)) {
      this.dialogService.openAlertGetMessage('E0122', ['適用開始受注コード(From)']);
      return false;
    }

    // 「適用開始受注コード(To)」
    // 存在チェック（入力時のみチェック）
    if ((vo.OrderCodeTo.length !== 0)
      && (PlessViewUtilsSub.isEmpty(this.lbl_DelivCatalogIdTo.nativeElement.value))) {
      this.dialogService.openAlertGetMessage('E0122', ['適用開始受注コード(To)']);
      return false;
    }

    // 「適用開始受注コード」チェック（「適用開始受注コード(To)」入力時のみ）
    if (vo.OrderCodeTo.length !== 0) {
      if (Number(vo.OrderCodeFrom) > Number(vo.OrderCodeTo)) {
        this.dialogService.openAlertGetMessage('E0123', ['適用開始受注コード']);
        return false;
      }
    }

    return true;
  }

  /**
   * ページネーション詳細設定の入力チェック
   *
   * @param vo    サーバへのリクエストデータ
   * @return true:OK false:NG
   */
  private inputCheckRegistPageCopy(vo: RegistPageCopyModel): boolean {
    // 「適用開始受注コード」
    // 必須チェック
    if (PlessViewUtilsSub.isEmpty(vo.OrderCode)) {
      this.dialogService.openAlertGetMessage('E0110', ['適用開始受注コード']);
      return false;
    }
    // 存在チェック
    if (PlessViewUtilsSub.isEmpty(this.lbl_DelivCatalogId.nativeElement.value)) {
      this.dialogService.openAlertGetMessage('E0122', ['適用開始受注コード']);
      return false;
    }

    // 「基版ページ作成生協」
    // 必須チェック
    if (PlessViewUtilsSub.trim(vo.CoopCode) === '') {
      this.dialogService.openAlertGetMessage('E0110', ['基版ページ作成生協']);
      return false;
    }

    // 「ページネーション詳細リスト」
    // 基版ページチェック
    let targetPageList: Array<any> = null;
    let targetCoopName: string = null;
    switch (vo.CoopCode) {
      case this.COOP_CODE[0]:                                                   // いばらき
        targetPageList = vo.IbarakiPageList;
        targetCoopName = this.kymw00Model.COOP_IB;
        break;

      case this.COOP_CODE[1]:                                                   // とちぎ
        targetPageList = vo.TochigiPageList;
        targetCoopName = this.kymw00Model.COOP_TO;
        break;

      case this.COOP_CODE[2]:                                                   // ぐんま
        targetPageList = vo.GunnmaPageList;
        targetCoopName = this.kymw00Model.COOP_GU;
        break;

      case this.COOP_CODE[3]:                                                   // ちば
        targetPageList = vo.ChibaPageList;
        targetCoopName = this.kymw00Model.COOP_TI;
        break;

      case this.COOP_CODE[4]:                                                   // さいたま
        targetPageList = vo.SaitamaPageList;
        targetCoopName = this.kymw00Model.COOP_SA;
        break;

      case this.COOP_CODE[5]:                                                   // とうきょう
        targetPageList = vo.TokyoPageList;
        targetCoopName = this.kymw00Model.COOP_TK;
        break;

      case this.COOP_CODE[6]:                                                   // ながの
        targetPageList = vo.NaganoPageList;
        targetCoopName = this.kymw00Model.COOP_NA;
        break;

      case this.COOP_CODE[7]:                                                   // にいがた
        targetPageList = vo.NiigataPageList;
        targetCoopName = this.kymw00Model.COOP_NI;
        break;

      case this.COOP_CODE[8]:                                                   // クルコ
        targetPageList = vo.KurucoPageList;
        targetCoopName = this.kymw00Model.COOP_KU;
        break;

      default:                                                                  // 指定なし
        // 「基版ページ作成生協」の必須入力チェックでエラーとなる
        break;
    }
    // 基版ページに 0 (未設定) が設定されている場合はエラー
    for (let i = Number(0); i < targetPageList.length; i++) {
      if (targetPageList[i] === '0') {
        this.dialogService.openAlertGetMessage('E0207', [targetCoopName, '基版ページ', '未設定を指定']);
        return false;
      }
    }

    // 「ページネーション詳細リスト」
    // 重複チェック
    let duplicationIndex: number = null;
    let duplicationPage: number = null;

    // いばらき
    if ((duplicationIndex = this.isDuplicationPage(vo.IbarakiPageList)) >= 0) {
      duplicationPage = duplicationIndex + 1;
      this.dialogService.openAlertGetMessage('E0115', ['いばらきの' + duplicationPage + 'ページ']);
      return false;
    }

    // とちぎ
    if ((duplicationIndex = this.isDuplicationPage(vo.TochigiPageList)) >= 0) {
      duplicationPage = duplicationIndex + 1;
      this.dialogService.openAlertGetMessage('E0115', ['とちぎの' + duplicationPage + 'ページ']);
      return false;
    }

    // ぐんま
    if ((duplicationIndex = this.isDuplicationPage(vo.GunnmaPageList)) >= 0) {
      duplicationPage = duplicationIndex + 1;
      this.dialogService.openAlertGetMessage('E0115', ['ぐんまの' + duplicationPage + 'ページ']);
      return false;
    }

    // ちば
    if ((duplicationIndex = this.isDuplicationPage(vo.ChibaPageList)) >= 0) {
      duplicationPage = duplicationIndex + 1;
      this.dialogService.openAlertGetMessage('E0115', ['ちばの' + duplicationPage + 'ページ']);
      return false;
    }

    // さいたま
    if ((duplicationIndex = this.isDuplicationPage(vo.SaitamaPageList)) >= 0) {
      duplicationPage = duplicationIndex + 1;
      this.dialogService.openAlertGetMessage('E0115', ['さいたまの' + duplicationPage + 'ページ']);
      return false;
    }

    // とうきょう
    if ((duplicationIndex = this.isDuplicationPage(vo.TokyoPageList)) >= 0) {
      duplicationPage = duplicationIndex + 1;
      this.dialogService.openAlertGetMessage('E0115', ['とうきょうの' + duplicationPage + 'ページ']);
      return false;
    }

    // ながの
    if ((duplicationIndex = this.isDuplicationPage(vo.NaganoPageList)) >= 0) {
      duplicationPage = duplicationIndex + 1;
      this.dialogService.openAlertGetMessage('E0115', ['ながのの' + duplicationPage + 'ページ']);
      return false;
    }

    // にいがた
    if ((duplicationIndex = this.isDuplicationPage(vo.NiigataPageList)) >= 0) {
      duplicationPage = duplicationIndex + 1;
      this.dialogService.openAlertGetMessage('E0115', ['にいがたの' + duplicationPage + 'ページ']);
      return false;
    }

    // クルコ
    if ((duplicationIndex = this.isDuplicationPage(vo.KurucoPageList)) >= 0) {
      duplicationPage = duplicationIndex + 1;
      this.dialogService.openAlertGetMessage('E0115', ['クルコの' + duplicationPage + 'ページ']);
      return false;
    }

    // ページ未入力チェック
    // いばらき
    if (!this.isInputAllPage(vo.IbarakiPageList)) {
      this.dialogService.openAlertGetMessage('E0110', ['ページ番号']);
      return false;
    }

    // とちぎ
    if (!this.isInputAllPage(vo.TochigiPageList)) {
      this.dialogService.openAlertGetMessage('E0110', ['ページ番号']);
      return false;
    }

    // ぐんま
    if (!this.isInputAllPage(vo.GunnmaPageList)) {
      this.dialogService.openAlertGetMessage('E0110', ['ページ番号']);
      return false;
    }

    // ちは
    if (!this.isInputAllPage(vo.ChibaPageList)) {
      this.dialogService.openAlertGetMessage('E0110', ['ページ番号']);
      return false;
    }

    // さいたま
    if (!this.isInputAllPage(vo.SaitamaPageList)) {
      this.dialogService.openAlertGetMessage('E0110', ['ページ番号']);
      return false;
    }

    // とうきょう
    if (!this.isInputAllPage(vo.TokyoPageList)) {
      this.dialogService.openAlertGetMessage('E0110', ['ページ番号']);
      return false;
    }

    // ながの
    if (!this.isInputAllPage(vo.NaganoPageList)) {
      this.dialogService.openAlertGetMessage('E0110', ['ページ番号']);
      return false;
    }

    // にいがた
    if (!this.isInputAllPage(vo.NiigataPageList)) {
      this.dialogService.openAlertGetMessage('E0110', ['ページ番号']);
      return false;
    }

    // クルコ
    if (!this.isInputAllPage(vo.KurucoPageList)) {
      this.dialogService.openAlertGetMessage('E0110', ['ページ番号']);
      return false;
    }

    return true;
  }

  /**
   * ページの重複をチェックする
   *
   * @param targetArray  チェック対象
   * @return -1:重複なし 0以上:重複箇所(配列のIndex値)
   */
  private isDuplicationPage(targetArray: Array<any>): number {
    for (let i = Number(0); i < targetArray.length; i++) {
      const comparisonNumber: number = parseInt(targetArray[i], 10);

      // 未設定のページはスキップする
      if (comparisonNumber === 0) {
        continue;
      }

      for (let j: number = i + 1; j < targetArray.length; j++) {
        if (parseInt(targetArray[j], 10) === comparisonNumber) {
          // 一致する項目があった場合
          return j;
        }
      }
    }

    return -1;
  }

  /**
   * ページの未入力をチェックする
   *
   * @param targetArray  チェック対象
   * @return true:未入力なし false:未入力有り
   */
  private isInputAllPage(targetArray: Array<any>): boolean {
    for (let i = Number(0); i < targetArray.length; i++) {
      if (targetArray[i] == null || targetArray[i] === '') {
        return false;
      }
    }

    return true;
  }

}
